'use client';

import dynamic from 'next/dynamic';
import { Container, useTranslation } from '@weareconceptstudio/core';

import { useState, useEffect } from 'react';
import { getTeams, getLeadership } from '@/libs/get-data';

//* Styles
import TeamTemplateStyle from './style';

//* Components
const Subscribe = dynamic(() => import('@/sections/Subscribe'));
const CareerSection = dynamic(() => import('@/sections/CareerSection'));
const JobOpportunitiesSection = dynamic(() => import('@/sections/JobOpportunitiesSection'));
const CategorySection = dynamic(() => import('../components/CategorySection'));

const TeamTemplate = () => {
	const { selectedLang } = useTranslation();
	const [teams, setTeams] = useState([]);
	const [leadership, setLeadership] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		Promise.all([getTeams({ lang: selectedLang }), getLeadership({ lang: selectedLang })])
			.then(([teamsRes, leadershipRes]) => {
				setTeams(teamsRes.data);
				setLeadership(leadershipRes.data);
				setLoading(false);
			})
			.catch((err) => {
				console.error(err);
				setLoading(false);
			});
	}, [selectedLang]);

	if (loading) return null;

	return (
		<TeamTemplateStyle>
			{leadership && (
				<div className='teams-block'>
					<CategorySection
						leadership={leadership}
						isFirst
					/>
				</div>
			)}

			{teams?.map((team, _) => (
				<div
					key={team.id}
					className='teams-block'>
					<CategorySection
						{...team}
						isFirst={false}
						members={team.members}
					/>
				</div>
			))}

			<Container>
				<Subscribe />
			</Container>

			<CareerSection />

			<Container>
				<JobOpportunitiesSection />
			</Container>
		</TeamTemplateStyle>
	);
};

export default TeamTemplate;
